import { Button, Modal, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  DownloadOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import AppContext from "../../context/app.context";
import { IAppContext } from "../../interfaces/context.interfaces";
import Loader from "../Animations/Loader";
import Style from "./Map.module.css";

const COMPACT_MODAL_WIDTH = "25%";
const COMPACT_MODAL_ENLARGED_WIDTH = "50%";

function MarkerImageModal({
  imageUrl,
  image,
  date,
  language,
  closeModal,
}: {
  imageUrl: string;
  image: string;
  date?: string | Date;
  language: string;
  closeModal: () => void;
}) {
  const appContext: IAppContext = useContext(AppContext);
  const [modalSize, setModalSize] = useState(COMPACT_MODAL_WIDTH);
  const [loaded, setLoaded] = useState(false);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [imageUrl]);

  const label = date ? new Date(date).toISOString().slice(0, 10) : null;

  const download = async () => {
    setDownloading(true);
    try {
      const { data } = await appContext.services.markerService.getImageUrl(
        image,
        true
      );
      const a = document.createElement("a");
      a.href = data;
      a.download = image;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      message.error(
        language === "de"
          ? "Bild konnte nicht heruntergeladen werden."
          : "Could not download the image."
      );
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Modal
      getContainer={"#root"}
      onCancel={() => {
        closeModal();
        setModalSize(COMPACT_MODAL_WIDTH);
      }}
      visible={!!imageUrl}
      footer={null}
      width={modalSize}
      style={{
        top: 20,
        right: 20,
        margin: 0,
        position: "absolute",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div style={{ position: "relative", minHeight: loaded ? 0 : 200 }}>
          {!loaded && <Loader />}
          <img
            src={imageUrl}
            alt={image}
            onLoad={() => setLoaded(true)}
            style={{
              width: "100%",
              display: loaded ? "block" : "none",
            }}
          />
          {loaded && label && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "5%",
                transform: "translateY(-50%)",
                padding: "10px 20px",
                background: "rgba(0, 0, 0, 0.5)",
                color: "white",
                borderRadius: "5px",
              }}
            >
              {label}
            </div>
          )}
        </div>
        <Button
          className={Style.enlargeCompareImage}
          onClick={() => setModalSize(COMPACT_MODAL_ENLARGED_WIDTH)}
          disabled={modalSize === COMPACT_MODAL_ENLARGED_WIDTH}
        >
          <ZoomInOutlined />
        </Button>
        <Button
          className={Style.minmizeComapreImage}
          onClick={() => setModalSize(COMPACT_MODAL_WIDTH)}
          disabled={modalSize === COMPACT_MODAL_WIDTH}
        >
          <ZoomOutOutlined />
        </Button>
        <Button
          className={Style.minmizeComapreImage}
          onClick={download}
          loading={downloading}
        >
          {!downloading && <DownloadOutlined />}{" "}
          {language === "de" ? "Bild" : "Image"}
        </Button>
      </div>
    </Modal>
  );
}

export default MarkerImageModal;
